"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newTextPinComponent = void 0;
const template_style_set_1 = require("../../templates/template-style-set");
const tip_tap_1 = require("../../tip-tap");
const geometry_1 = require("../geometry");
const order_1 = require("../order");
const random_id_1 = require("../random-id");
const defaultStyle_1 = require("../styles/defaultStyle");
const pin_component_1 = require("./pin-component");
function newTextPinComponent({ content = (0, tip_tap_1.stringToProsemirror)('Text'), position = pin_component_1.initialPinComponentPosition, size = (0, geometry_1.newSize)(175, 175), rotation = 0, settings = {}, order = order_1.defaultOrder, id, useDefaultTemplateStyles = true, }) {
    return {
        type: 'TEXT',
        id: id || (0, random_id_1.randomId)(),
        settings: {
            tipTapContent: content,
            ...(useDefaultTemplateStyles ? (0, defaultStyle_1.defaultStyleForTemplateStyles)(template_style_set_1.LessonUpStyleSets) : {}),
            ...settings,
        },
        layout: (0, geometry_1.newBox)(position, size, rotation),
        order,
    };
}
exports.newTextPinComponent = newTextPinComponent;
//# sourceMappingURL=text-pin-component.js.map